import { AlertTriangle, Check, Clock3, LoaderCircle, XCircle } from "lucide-react";
import type { IngestionState } from "../../shared/types";

const labels: Record<IngestionState, string> = {
  uploaded: "Uploaded",
  queued: "Queued",
  processing: "Processing",
  recovering: "Recovering",
  review_required: "Review required",
  ready: "Ready",
  failed: "Failed",
};

export function StatusBadge({ state }: { state: IngestionState }) {
  const Icon = state === "ready" ? Check : state === "failed" ? XCircle : state === "review_required" ? AlertTriangle : state === "processing" || state === "recovering" ? LoaderCircle : Clock3;
  return <span className={`status status--${state}`}><Icon size={13} aria-hidden="true" />{labels[state]}</span>;
}
